/**
 * Inputモジュール
 *
 * No.    日付          更新者    更新内容
 *   1    2021/09/06    大友      新規作成
 *
 * @summary common
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import {Util} from './util';
import {Str} from './string';
import {ZipCode} from './form/zipcode';

const Input = {
    /**
     * 入力制限(数値のみ)
     *
     * @param {input|string} $control コントロールまたはinputセレクター
     * @param {boolean} zeroPadding ゼロ埋めする場合はtrue
     * @returns {void}
     */
    numericOnly: function(target, zeroPadding = true) {
        let input = null;
        if (typeof target === 'string') {
            // 文字列なら
            input = document.querySelector(target);
        } else if (Util.isElement(target)) {
            input = target;
        }

        if (input === null) {
            throw 'コントロールが見つかりません';
        }

        input.addEventListener('keydown', function(event) {
            const keyCode = event.keyCode;
            // 0-9
            if (48 <= keyCode && keyCode <= 57 && !event.shiftKey) {
                return true;
            }
            // テンキー
            if (96 <= keyCode && keyCode <= 105 && !event.shiftKey) {
                return true;
            }
            // PFキー
            if (112 <= keyCode && keyCode <= 123) {
                return true;
            }
            // 制御文字
            if (keyCode <= 46) {
                return true;
            }
            event.preventDefault();
        }, false);

        input.addEventListener('blur', function(event) {
            this.value = this.value.replace(/[０-９]/g,s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '');

            if (zeroPadding) {
                // maxlength属性で0埋め
                const maxlength = parseInt(this.getAttribute('maxlength'), 10);
                if (this.value.length > 0 && maxlength > 0) {
                    this.value = Str.padStart(this.value, maxlength, '0');
                }
            }
        }, false);
    }
};

Input.ZipCode = ZipCode;

export { Input };
